




























































import cookies from 'js-cookie';
import {checkHasPddAppAndSetLocalStorage, getAssetURL, setNavTitle} from 'common/util';
import MJSSDK from '@mfex/mjssdk';
import {Icon as MaiIcon, NavBar as MaiNavBar, ScrollDetector as MaiScrollDetector, Sticky} from '@mfex/mai-ui';

import {scrollToTop} from '@mfex/mai-ui/es/components/back-top';
import GoldCoinToast from 'v-component/smart/gold-coin-toast.vue';
import JumpTbDialog from 'v-component/smart/jump-tb-dialog.vue';
import {BackGold, Gold} from 'common/mai-typing';
import {loginIntercept} from 'common/user-info';
import tinycolor from 'tinycolor2';
import PageVisibility from 'v-mixin/page-visibility';
import {usePid} from 'js/v-hook/use-pid';

export default {
    name: 'App',
    components: {MaiNavBar, Sticky, MaiScrollDetector, GoldCoinToast, MaiIcon, JumpTbDialog},
    mixins: [PageVisibility],
    provide() {
        return {$app: this};
    },
    setup() {
        return {
            pid: usePid()
        };
    },
    data() {
        return {
            navActive: true,
            tag: null,
            // 这个 title 最优先
            navTitle: '',
            showGoldCoinToast: false,
            goldCoinMsg: {} as Gold,
            BI_TYPE: '' // bi 点位
        };
    },
    computed: {
        isWapBrowser() {
            return !MJSSDK.UA.app && !MJSSDK.UA.wx; // todo: 这里 MJSSDK.UA.app 判断不准
        }
    },
    watch: {
        $route(to) {
            if (to.name !== 'index') {
                this.setAppBarColor();
            }
        }
    },
    created() {
        this.setAppBarColor();
        checkHasPddAppAndSetLocalStorage();

        this.$router.afterEach(to => {
            const title = to.meta.title;
            this.setTitle(title);
            this.setNavActive(true);
        });
        this.wxLogin();
    },
    activated() {
        this.setAppBarColor();
    },
    mounted() {
        this.initGoldCoinToast();
    },
    methods: {
        setAppBarColor(color = '#202230', bg = '#ffffff') {
            const canSetColor = tinycolor(color).isValid() && tinycolor(bg).isValid(); // 检验颜色格式
            if (canSetColor && MJSSDK.UA.mamaApp && MJSSDK.compareVer('8.3') !== -1) {
                if (bg === '#ffffff' || bg === '#fff') {
                    MJSSDK.setNavShareButtonColor({
                        imgUrl: `${location.protocol}${getAssetURL('img/share-black.png')}`,
                        color: '#202230'
                    });

                    MJSSDK.setNavBackButtonColor({
                        imgUrl: `${location.protocol}${getAssetURL('img/back-black.png')}`,
                        color: '#202230'
                    });
                } else {
                    MJSSDK.setNavShareButtonColor({
                        imgUrl: `${location.protocol}${getAssetURL('img/icon-share-w.png')}`,
                        color: '#ffffff'
                    });

                    MJSSDK.setNavBackButtonColor({
                        imgUrl: `${location.protocol}${getAssetURL('img/icon-back-w.png')}`,
                        color: '#ffffff'
                    });
                }

                // 防止颜色值不对会导致 app 闪退
                // 状态栏标题 8.3 才支持
                MJSSDK.setNavTitleColor({
                    color: color
                });

                // 状态栏背景 8.3 才支持
                MJSSDK.setNavBGColor({
                    color: bg
                });
            }
        },
        setTitle(title: string): void {
            if (title) {
                this.navTitle = title;
                setNavTitle(title);
            }
        },
        showSetch() {
            const tempImage = document.getElementById('index-image');
            if (tempImage) {
                tempImage.style.display = 'block';
            }
        },
        hideSetck() {
            // 隐藏占位图片
            const tempImage = document.getElementById('index-image');
            if (tempImage) {
                tempImage.style.display = 'hide';
            }
        },
        setNavActive(bool: boolean): void {
            this.navActive = bool;
        },
        navBarClick(id: string): void {
            switch (id) {
                case 'left-0':
                    {
                        this.$router.back();
                    }
                    break;

                case 'right-0': {
                    this.$router.push('/search');
                }
            }
        },
        initGoldCoinToast() {
            const INIT_DATA = cookies.get('initDataAward') || '';
            let initData = null;
            if (INIT_DATA) {
                try {
                    initData = JSON.parse(INIT_DATA);
                } catch (err) {
                    console.error(err);
                }
                if (initData && initData.award && initData.award.opt_text) {
                    const award: BackGold = initData.award;
                    this.goldCoinMsg = {
                        desc: award.opt_text,
                        num: award.opt_act,
                        unit: award.opt_unit
                    };
                    this.showGoldCoinToast = true;
                    cookies.remove('initDataAward', {
                        path: '/',
                        domain: window.location.hostname
                    });
                    setTimeout(() => {
                        this.showGoldCoinToast = false;
                    }, 2000);
                }
            }
        },
        wxLogin() {
            if (MJSSDK.UA.wx) {
                loginIntercept();
            }
        },
        goTop() {
            scrollToTop(this.$refs.content);
        }
    }
};
